import { Dialog, styled } from "@mui/material"

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export function calculatePageCount(apiMetadata: ApiMetadata | undefined): number {
    if (apiMetadata !== undefined) {
        return Math.ceil(apiMetadata.count / apiMetadata.perPage)
    } else {
        return 1
    }

}

export interface ApiMetadata {
    count: number,
    page: number,
    perPage: number
}

export interface ApiResultWrapper<T> {
    data: T[],
    metadata: ApiMetadata
}

export interface AvailableJournal {
    journalName: string,
    journalId: string,
    issn: string,
}

export interface Article {
    doi: string,
    title: string,
    authorships: Author[],
    publicationDate: string,
    scitilityRiskScore: number
}

export interface RetractedWork {
    title: string,    
    journal: string,
    publisher: string,
    authors: string[],
    originalPaperDoi: string,
    retractionDoi: string,
    originalPaperDate: string,
    retractionDate: string,
    retractionNature: string    
    reasons: string[],
    notes: string,
    source: string,
    highRisk: boolean
}

export interface AuthorIds{
    openAlexId: string,
    orcid: string
}


export interface RetractedAuthor {
    ids: AuthorIds
    displayName: string,
    displayNameAlternatives: string[],
    institutions: string[],
    worksCount: number,
    citedByCount: number,
    hIndex: number,
    retractedWorksCount: number,
    retractedWorks: RetractedWork[]
}

export interface AuthorAnnualMetrics {    
    year: number,
    analysed: number,
    retractions: number,
    highRisk: number,
    mediumRisk: number
    //lowRiskArticles: number
}


export interface RiskScoreAnalysis {
    doi: string,
    title: string,
    authorships: Author[],
    publisherName: string,
    source: string,
    publicationDate: string,
    numberProblematicReferences: number,
    numberProblematicAuthors: number,
    isAlreadyRetracted: boolean,
    isRetractionNote: boolean,
    scitilityRiskScore: number,
    authorAnalysis: AuthorAnalysis[]
    referencesAnalysis: ReferenceAnalysis[],
    lastUpdatedTime: string,
    totalNumberOfDifferentHighRiskRetractions: number,
    totalNumberOfDifferentLowRiskRetractions: number
}

export interface Author {
    orcid: string | null,
    rawAuthorName: string,
    institutions: Institutions[]
}

export interface Institutions {
    displayName: string,
    countryCode: string,
    ror: string | null
}

export interface AuthorAnalysis {
    authorDisplayName: string,
    openAlexId: string,
    problemsFound: DehydratedRetractionWork[]
}

export interface DehydratedRetractionWork {
    recordId: string,
    title: string,
    journal: string,
    originalPaperDoi: string,
    retractionDoi: string,
    originalPaperDate: string,
    retractionDate: string,
    retractionNature: string,
    highRisk: boolean
}

export interface ReferenceAnalysis {
    referenceOpenAlexId: string,
    doi: string,
    problemsFound: boolean
}

export interface OpenAlexReferenceData {
    doi: string,
    title: string,
    retractionDate: string | null
}


export interface DrillDownParams {
    publisherIds?: string,
    journalIds?: string,
    startYear: number,
    endYear: number,
    drillDownTitle: string,
    queryRetractions: boolean,
    scitilityRiskScoreLowerBoundary: number,
    scitilityRiskScoreHigherBoundary?: number,
    institutionId?: string,
    authorId?: string,
    embed?: boolean
}

export interface InstitutionalDashboardParams {
    institutionId: string
    institutionName: string
}